import { css } from '@emotion/css/macro';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  color: #42607f;
  padding: 40px 0;
  h2 {
    font-size: 22px;
    text-align: center;
    line-height: 1.55;
    letter-spacing: -0.82px;
    b {
      font-weight: bold;
    }
  }
  img {
    left: 0;
    margin: 36px auto;
  }
  #reason1 {
    width: 110px;
  }
  #reason3 {
    width: 230px;
  }
`;
const imgGroup = css`
  display: flex;
  flex-direction: row;
  left: 0;
  margin: 45px auto;
`;
const box = css`
  width: 88px;
  height: 104px;
  border-radius: 33px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.3);
  background-image: linear-gradient(to bottom, #f9f9f9, #e8e8e8);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 42px;
  margin: -14px -8px;
  z-index: 2;
`;
const circleGroup = css`
  z-index: 3;
`;
const circle = css`
  border-radius: 48px;
  width: 66px;
  height: 66px;
  margin: -14px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.52px;
  color: #f7f7f7;
`;

export default function ReasonView() {
  return (
    <div className='swiper-no-swiping'>
      <section className={style}>
        <h2>
          강아지의 문제행동은
          <br />
          <b>못된 행동이 아니라</b>
        </h2>
        <img id='reason1' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-reason1.png' />
        <h2>
          <b>규칙과 약속이 없어</b> 혼란스러운
          <br />
          <b>강아지의 불안한 행동</b>입니다.
        </h2>
        <div className={imgGroup}>
          <div className={box}>💁🏻‍♀️</div>
          <div className={circleGroup}>
            <div className={circle} style={{ backgroundColor: 'rgba(244, 140, 149, 0.9)' }}>
              규칙
            </div>
            <div className={circle} style={{ backgroundColor: 'rgba(80, 227, 194, 0.8)' }}>
              약속
            </div>
          </div>
          <div className={box}>🐶</div>
        </div>
        <h2>
          <b>
            문제 행동을
            <br />
            예방하거나 개선
          </b>
          하기 위해서는
        </h2>
        <img id='reason3' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-reason3.png' />
        <h2>
          <b>
            규칙을 정하고 약속을 만드는
            <br />
            올바른 양육
          </b>
          이 필요해요 🏄🏻‍♀️
        </h2>
      </section>
    </div>
  );
}
